import styled from 'styled-components';

export const Form = styled.form`
  min-width: ${({ theme }) => theme.spacing[96]}; ;
`;
